// Catalogo de escopos M2M OFERECIDO no self-service do PCP (decisao F2.1 do
// owner, 2026-07-20; ampliado a DOZE em 2026-07-29; a QUINZE em 2026-08-04
// com `operation:cancel`, `contract:read` e `contract:send`; a DEZESSETE em
// 2026-10-20 com `assignor_document:read` e `assignor_document:write`).
//
// FONTE CANONICA do que a API aceita: v2 backend/app/api/v1/middlewares/scope_map.py
// (`valid_scopes()`, derivado de _RESOURCE_SCOPES + _EXACT_OVERRIDES + _ACTION_SCOPES),
// aplicado fail-closed em backend/app/api/v1/routes/portal_tokens.py:104-118
// (`PortalTokenCreate._scopes_must_be_known` -> 422 para escopo fora do catalogo).
// Os dezessete abaixo sao o recorte OFERECIDO na tela; o catalogo tecnico
// completo (o de `valid_scopes()` da V2; contagem da V2, sem medir aqui)
// continua exclusivo do Backoffice.
//
// ATENCAO — catalogo de SELECAO (17) != recorte da SK (14). A SK e o conjunto
// FIXO `SELF_SERVICE_SCOPES` do backend (ver SK_SCOPE_VALUES abaixo) e NAO
// cresce quando este catalogo cresce; escopo alem dos 14 so sai numa RK.
// Derivar a SK deste catalogo produziria um POST com 17 escopos e `kind=SK`
// => 422 da V2 (`_kind_matches_the_scope_shape`, portal_tokens.py).
//
// CONTRATO BILATERAL (exigencia dos dois arquivos): mudanca aqui exige a
// mudanca espelhada em v2 backend/app/api/v1/routes/portal_tokens.py
// (`SELF_SERVICE_SCOPES`) na MESMA leva — e vice-versa. Os dois lados se
// citam de proposito; o guarda do lado V2 e tests/unit/test_portal_token_kind.py
// e o deste lado e tokenScopes.test.js.
//
// `assignor:read` e `payer:read` entraram por decisao do owner (2026-07-28): sem o
// read do recurso, um token so com `:write` levava 403 ao consultar o que acabara
// de gravar. Ambos existem em _RESOURCE_SCOPES (scope_map.py:23-24).
//
// `operation:cancel`, `contract:read` e `contract:send` entraram por decisao do
// owner (2026-08-04, queue LEVA-EMB-1) — e TAMBEM no recorte da SK (9 -> 12).
//
// CISAO EMB-6 (decisao do owner, 2026-08-04): o escopo unico `contract:sign`
// (que nunca chegou a producao) virou DOIS — `contract:read`, no grupo de
// consulta, para o GET do status/signatarios/URLs (escopo de RECURSO da V2,
// `/v1/contracts` em _RESOURCE_SCOPES), e `contract:send`, no grupo de acoes,
// para o POST do envio (escopo de ACAO, `_ACTION_SCOPES`). As rotas que os
// consomem (`/v1/operations/{id}/contract/*`) chegam pela branch de assinatura
// embedded.
//
// `webhook:read`, `webhook:write` e `originator:read` entraram por decisao do
// owner (2026-07-29, lista final de 12): existem em _RESOURCE_SCOPES
// (`/v1/webhooks` e `/v1/originators`) e estao na tabela de scopes de
// v2 docs-portal/docs/reference/scopes.md. Ficam FORA da SK — entram so por
// selecao explicita numa RK.
//
// `assignor_document:read` e `assignor_document:write` entraram por decisao do
// owner (2026-10-20, DEZESSETE: DOEP4-A C1011254 — o originador marca as 2
// permissoes na tela de chaves do PCP; textos das 2 opcoes = DOEP5-A C1011282):
// `:read` no grupo Consulta, `:write` no grupo Acoes (escrita => allowlist de IP
// pela regra A). Desde 2026-10-31 (owner C1014458, SPEC SK14) os 2 entram
// TAMBEM no recorte da SK (12 -> 14). Pre-requisito de deploy: a V2 com a SK de
// 14 aceita (`SELF_SERVICE_SCOPES` + janela 14/12/9) ANTES deste Portal — a V2
// anterior recusa a SK de 14 com 422.
//
// Escopos NO PLURAL (`operations:*`) e de saldo (`balance:read`, `admin:balance:read`)
// NAO existem no catalogo da V2 e nunca podem voltar a esta tela — ver tokenScopes.test.js.
import {
  COPY_STEPUP,
  ERROR_STEP_UP_REQUIRED,
  ERROR_TWO_FACTOR_ENROLLMENT_REQUIRED,
} from "./stepUp";

export const TOKEN_SCOPE_GROUPS = [
  {
    id: "read",
    label: "Consulta",
    options: [
      { value: "operation:read", product: "Operações", description: "Consultar operações" },
      { value: "stock:read", product: "Estoque", description: "Consultar itens do estoque" },
      { value: "assignor:read", product: "Cedentes", description: "Consultar cedentes" },
      { value: "payer:read", product: "Sacados", description: "Consultar sacados" },
      { value: "webhook:read", product: "Webhooks", description: "Consultar webhooks e suas entregas" },
      { value: "originator:read", product: "Originador", description: "Consultar os dados do originador" },
      {
        value: "contract:read",
        product: "Contratos",
        description: "Consultar status do contrato, signatários e URLs de assinatura",
      },
      {
        value: "assignor_document:read",
        product: "Documentos do cedente",
        description: "Consultar o estado dos documentos e os sócios dos cedentes",
      },
    ],
  },
  {
    id: "write",
    label: "Ações",
    options: [
      { value: "simulation:create", product: "Simulações", description: "Simular antecipação" },
      { value: "operation:create", product: "Operações", description: "Criar operações" },
      { value: "stock:write", product: "Estoque", description: "Registrar e cancelar itens do estoque" },
      { value: "assignor:write", product: "Cedentes", description: "Cadastrar e editar cedentes" },
      { value: "payer:write", product: "Sacados", description: "Cadastrar e editar sacados" },
      { value: "webhook:write", product: "Webhooks", description: "Cadastrar, editar e remover webhooks" },
      { value: "operation:cancel", product: "Operações", description: "Cancelar operações" },
      {
        value: "contract:send",
        product: "Contratos",
        description:
          "Disparar manualmente o envio do contrato para assinatura (re-envio após erro e casos de borda; o envio normal é automático)",
      },
      {
        value: "assignor_document:write",
        product: "Documentos do cedente",
        description: "Enviar documentos e cadastrar sócios dos cedentes",
      },
    ],
  },
];

export const TOKEN_SCOPE_OPTIONS = TOKEN_SCOPE_GROUPS.flatMap((group) => group.options);

export const TOKEN_SCOPE_VALUES = TOKEN_SCOPE_OPTIONS.map(({ value }) => value);

const CANONICAL_SCOPES = new Set(TOKEN_SCOPE_VALUES);

// ---------------------------------------------------------------------------
// Recorte da SK — conjunto FIXO de CATORZE, deliberadamente NAO derivado do
// catalogo de selecao acima.
//
// Espelha `SELF_SERVICE_SCOPES` de v2 backend/app/api/v1/routes/portal_tokens.py:
// a V2 exige que uma `kind=SK` traga EXATAMENTE uma forma aceite (a corrente,
// estes catorze; nem a mais, nem a menos) e recusa com 422 qualquer RK que os
// CONTENHA todos (guard RK-nao-superset). Lista LITERAL de proposito: o catalogo
// de selecao tem 17 e a SK so 14 — se este recorte fosse
// `[...TOKEN_SCOPE_VALUES]`, a tela passaria a postar o catalogo inteiro com
// kind=SK e toda emissao de acesso completo morreria em 422. Mudar esta lista
// exige mexer no backend na MESMA leva.
//
// ORDEM: canonica do catalogo de selecao (TOKEN_SCOPE_VALUES filtrado) — por
// isso `contract:read` e `assignor_document:read` vem entre os `:read` e nao
// junto de `contract:send` / `assignor_document:write`.
//
// JANELA DE DEPLOY 12 -> 14 (2026-10-31, owner C1014458; molde da 9 -> 12 de
// 2026-08-04): a V2 nova aceita, para `kind=SK`, a forma de 14, a de 12 ou a de
// 9. A janela cobre SO a ordem V2 primeiro, Portal depois, em cada ambiente: a
// V2 anterior recusa a SK de 14 com 422, entao este Portal NUNCA vai antes dela.
// NAO ha formato intermediario aceito (nem o 13 = 12 + um de documentos). O
// expurgo da forma de 12 acontece depois que os dois lados estiverem em
// producao com 14 (item na owner-queue).
// ---------------------------------------------------------------------------
export const SK_SCOPE_VALUES = [
  "operation:read",
  "stock:read",
  "assignor:read",
  "payer:read",
  "contract:read",
  "assignor_document:read",
  "simulation:create",
  "operation:create",
  "stock:write",
  "assignor:write",
  "payer:write",
  "operation:cancel",
  "contract:send",
  "assignor_document:write",
];

const SK_SCOPES = new Set(SK_SCOPE_VALUES);

// Formas ANTERIORES da SK, LITERAIS (nunca derivadas de SK_SCOPE_VALUES): a de 12
// (2026-08-04) e a de 9 (2026-07-28). Junto com a corrente (14) espelham
// `_SK_ACCEPTED_SHAPES` da V2 (portal_tokens.py) durante a janela 12 -> 14. Uso
// UNICO: reconhecer, na ROTACAO, uma SK emitida numa forma aceite — a tela nunca
// EMITE estas formas (a emissao e sempre a corrente).
const _SK_SHAPE_12 = [
  "operation:read",
  "stock:read",
  "assignor:read",
  "payer:read",
  "contract:read",
  "simulation:create",
  "operation:create",
  "stock:write",
  "assignor:write",
  "payer:write",
  "operation:cancel",
  "contract:send",
];
const _SK_SHAPE_9 = [
  "operation:read",
  "stock:read",
  "assignor:read",
  "payer:read",
  "simulation:create",
  "operation:create",
  "stock:write",
  "assignor:write",
  "payer:write",
];
const _SK_ACCEPTED_SHAPES = [SK_SCOPE_VALUES, _SK_SHAPE_12, _SK_SHAPE_9].map(
  (shape) => new Set(shape)
);

// Igualdade de CONJUNTO com uma das formas aceites (14, 12, 9) — nem a mais, nem a
// menos. Vazio nunca casa (nenhuma forma e vazia).
function isAcceptedSkShape(values) {
  const set = new Set(values ?? []);
  return _SK_ACCEPTED_SHAPES.some(
    (shape) => shape.size === set.size && [...shape].every((scope) => set.has(scope))
  );
}

export const SK_SCOPE_COUNT = SK_SCOPE_VALUES.length;

// O conjunto contem TODO o recorte da SK? E a fronteira que a V2 aplica:
// `kind=SK` exige igualdade e `kind=RK` proibe superset.
function containsAllSkScopes(values) {
  const set = new Set(values ?? []);
  return SK_SCOPE_VALUES.every((scope) => set.has(scope));
}

function isExactlySkScopes(values) {
  const set = new Set(values ?? []);
  return set.size === SK_SCOPES.size && containsAllSkScopes(set);
}

// Presets sao REGRA, nao lista (decisao ratificada 2026-07-20): "Visualização" =
// os `:read` do catalogo. Derivar pelo SUFIXO — e nao pelo grupo — garante que
// incluir um escopo novo de leitura no catalogo ja o coloque na Visualização,
// sem segunda lista para esquecer.
//
// `full` e a EXCECAO: e o recorte da SK (os 14), NAO o catalogo inteiro. Desde
// 2026-07-29 as duas coisas divergem, e quem define `full` e o backend.
export const TOKEN_SCOPE_PRESETS = {
  read: TOKEN_SCOPE_VALUES.filter((value) => value.endsWith(":read")),
  full: [...SK_SCOPE_VALUES],
};

// Produtos cobertos pela Visualização — a copy da tela sai DAQUI para nao
// envelhecer a cada escopo novo (envelheceu neste round: era "operações e estoque").
export const TOKEN_SCOPE_READ_PRODUCTS = [
  ...new Set(
    TOKEN_SCOPE_OPTIONS.filter(({ value }) => value.endsWith(":read")).map(
      ({ product }) => product
    )
  ),
];

export const DEFAULT_TOKEN_SCOPES = [...TOKEN_SCOPE_PRESETS.read];

export const SCOPE_MODES = ["read", "full", "custom"];

// ---------------------------------------------------------------------------
// Taxonomia SK/RK (M8/F4 — PLANO-ZK-SELF-SERVICE-PCP §2).
//
// SK = credencial PLENA: `scopes` == recorte da SK (SK_SCOPE_VALUES, os 14) EXATO.
// RK = credencial de escopo MINIMO: qualquer selecao do catalogo (17) que NAO
//      contenha os 14 da SK. Note o `nao contenha` (superset), nao `!=`: os 14 +
//      um escopo extra e ESTRITAMENTE mais ampla que uma SK e nao pode sair com
//      prefixo `rk_live_` — e o guard RK-nao-superset da V2.
//
// `kind` e campo EXPLICITO do request — a V2 persiste o valor recebido e NUNCA
// o infere (§2). Aqui ele nasce de uma escolha do usuario na tela; o que estas
// funcoes garantem e que a escolha jamais chegue à API CONTRADIZENDO os escopos
// (a V2 responde 422 para `SK` + subconjunto proprio e para `RK` + catalogo
// completo). Isto e coerencia local fail-closed, nao inferencia.
//
// O prefixo do SECRET e o sinal visivel da classe (`sk_live_` / `rk_live_`);
// ele e gerado na V2 e so e LIDO aqui — a tela nunca o fabrica.
// ---------------------------------------------------------------------------
export const CREDENTIAL_KINDS = ["RK", "SK"]; // RK primeiro: e o recomendado

// Default RECOMENDADO da tela: escopo minimo limita o raio de um vazamento.
export const DEFAULT_CREDENTIAL_KIND = "RK";

export const CREDENTIAL_KIND_META = {
  RK: {
    kind: "RK",
    prefix: "rk_live_",
    title: "Escopo mínimo (RK)",
    short: "RK",
    // Terminologia unificada (gate UX, M5): o OBJETO chama-se "credencial" e o
    // que vaza é o "secret". "chave" saiu da copy — era um quarto nome para a
    // mesma coisa na mesma tela.
    summary:
      "Só as permissões que esta integração usa. Se o secret vazar, o estrago " +
      "para no escopo dela. Recomendado — crie uma RK por integração.",
    secretHint:
      "O prefixo rk_live_ marca uma credencial de ESCOPO MÍNIMO: ela só alcança " +
      "as permissões selecionadas na criação.",
  },
  SK: {
    kind: "SK",
    prefix: "sk_live_",
    title: "Acesso completo (SK)",
    short: "SK",
    // Copy FACTUAL: enumera o que a credencial alcanca em vez de figura de
    // linguagem. "o raio de um vazamento e a conta inteira" prometia MAIS do que
    // o recorte da SK cobre — nao ha saldo, pagamento nem rota admin nestes
    // escopos. O numero sai de SK_SCOPE_VALUES (14), NAO do catalogo de selecao
    // (17): a SK nao alcanca webhooks nem os dados do originador.
    summary:
      `Todas as ${SK_SCOPE_COUNT} permissões do acesso completo — ` +
      "inclusive criar operações e editar cedentes/sacados. Se o secret vazar, " +
      "tudo isso vai junto.",
    secretHint:
      "O prefixo sk_live_ marca uma credencial PLENA: ela alcança todas as " +
      "permissões do acesso completo.",
  },
};

// Modos de escopo oferecidos por classe: SK e o recorte dos 14 por definicao,
// entao nao tem o que escolher; RK escolhe entre o preset de leitura e o custom.
export const SCOPE_MODES_BY_KIND = { SK: ["full"], RK: ["read", "custom"] };

// Modo -> classe. `full` e, por definicao, o recorte da SK == SK.
export function kindForMode(mode) {
  return mode === "full" ? "SK" : "RK";
}

// Classe implicada por um conjunto de escopos (usada para LER credencial ja
// emitida quando a V2 nao devolve `kind` — nunca para decidir o que enviar).
// Compara com o recorte da SK e sobre a lista CRUA: um conjunto com os 14 mais
// um escopo tecnico do Backoffice nao e uma SK (a V2 nem a emitiria assim).
export function kindForScopes(scopes) {
  return isExactlySkScopes(scopes ?? []) ? "SK" : "RK";
}

// Le a classe de uma credencial JA EMITIDA, na ordem de confianca:
// campo `kind` da API > prefixo do secret one-time > escopos. Devolve null
// quando nada permite concluir (V2 antiga listando sem `kind`, sem secret).
export function kindFromSecret(secret) {
  if (typeof secret !== "string") return null;
  if (secret.startsWith(CREDENTIAL_KIND_META.SK.prefix)) return "SK";
  if (secret.startsWith(CREDENTIAL_KIND_META.RK.prefix)) return "RK";
  return null;
}

export function issuedCredentialKind(credential) {
  if (!credential) return null;
  if (CREDENTIAL_KINDS.includes(credential.kind)) return credential.kind;
  const fromSecret = kindFromSecret(credential.secret);
  if (fromSecret) return fromSecret;
  if (Array.isArray(credential.scopes) && credential.scopes.length > 0) {
    return kindForScopes(credential.scopes);
  }
  return null;
}

// Ordem canonica do catalogo: o estado nao pode depender da ordem de clique.
function canonicalize(values) {
  return TOKEN_SCOPE_VALUES.filter((value) => values.includes(value));
}

// ---------------------------------------------------------------------------
// Maquina de estado PURA da selecao de escopos.
//
// Toda a selecao vive aqui e o componente e consumidor burro — e o que permite
// testar TRANSICOES (comportamento) em vez de casar substring no JSX. Invariante
// central: nenhum escopo fora de TOKEN_SCOPE_VALUES entra no estado — escopo
// desconhecido e IGNORADO, nunca propagado (fail-closed).
//
// `customScopes` guarda a ultima selecao personalizada para que passar por um
// preset (inclusive por navegacao de seta no radiogroup) nao a destrua.
// ---------------------------------------------------------------------------
export function initialScopeState() {
  return {
    kind: DEFAULT_CREDENTIAL_KIND,
    mode: "read",
    scopes: [...TOKEN_SCOPE_PRESETS.read],
    customScopes: null,
  };
}

export function nextScopeState(mode, prev) {
  if (!SCOPE_MODES.includes(mode)) return prev;
  if (mode === "custom") {
    // Herda o preset corrente na primeira entrada; depois disso, restaura a
    // ultima selecao personalizada.
    const inherited = canonicalize(prev.customScopes ?? prev.scopes);
    return { ...prev, kind: kindForMode(mode), mode, scopes: inherited, customScopes: inherited };
  }
  return {
    ...prev,
    kind: kindForMode(mode),
    mode,
    scopes: [...TOKEN_SCOPE_PRESETS[mode]],
    customScopes: prev.customScopes,
  };
}

// Escolha EXPLICITA da classe (passo 1 da criacao). Ela conduz os presets:
// SK trava o recorte dos 14; RK devolve o usuario ao escopo minimo —
// restaurando a ultima selecao personalizada, se houver, em vez de zera-la.
export function nextKindState(kind, prev) {
  if (!CREDENTIAL_KINDS.includes(kind)) return prev;
  if (kind === "SK") return nextScopeState("full", prev);
  return nextScopeState(prev.customScopes ? "custom" : "read", prev);
}

// Coerencia local com a validacao fail-closed da V2 (§2 + guard
// RK-nao-superset): `SK` exige o recorte dos 14 EXATO, `RK` nao pode CONTER os 14.
// Devolve null quando esta coerente, ou uma mensagem acionavel — a tela BLOQUEIA
// antes de virar 422 remoto.
//
// O gatilho da RK e o SUPERSET, nao a igualdade: com o catalogo de selecao em 17,
// marcar os 14 + `webhook:read` produz uma chave mais ampla que uma SK saindo com
// prefixo `rk_live_` — exatamente o que a V2 recusa.
export function kindMismatch(state) {
  const kind = state?.kind;
  if (!CREDENTIAL_KINDS.includes(kind)) return null;
  const selected = canonicalize(state?.scopes ?? []);
  if (kind === "SK" && !isExactlySkScopes(selected)) {
    return `Acesso completo exige as ${SK_SCOPE_COUNT} permissões dele, sem sobra. Troque para escopo mínimo (RK) para escolher outro conjunto.`;
  }
  if (kind === "RK" && containsAllSkScopes(selected)) {
    // Remediacao EXATA por caso, espelhando portal_tokens.py
    // (`_kind_matches_the_scope_shape`): "troque para SK" so resolve sozinho
    // quando a selecao e IGUAL aos 14. Com extras marcados, virar SK exigiria
    // tambem desmarcar os extras — oferecer o atalho seco mandaria o master
    // direto para um segundo erro.
    const remedy = isExactlySkScopes(selected)
      ? "Desmarque ao menos uma delas ou troque para acesso completo (SK)."
      : `Desmarque ao menos uma delas — ou troque para acesso completo (SK) deixando só essas ${SK_SCOPE_COUNT}, sem os extras.`;
    return `Escopo mínimo não pode reunir as ${SK_SCOPE_COUNT} permissões do acesso completo. ${remedy}`;
  }
  return null;
}

export function toggleScopeState(scope, prev) {
  if (prev.mode !== "custom") return prev;
  if (!CANONICAL_SCOPES.has(scope)) return prev;
  const scopes = canonicalize(
    prev.scopes.includes(scope)
      ? prev.scopes.filter((value) => value !== scope)
      : [...prev.scopes, scope]
  );
  return { ...prev, scopes, customScopes: scopes };
}

// Fronteira de saida: o corpo enviado a API sai DAQUI e de mais lugar nenhum.
// Fail-closed — se um escopo nao-canonico chegou ao estado por qualquer via, a
// criacao para com erro explicito em vez de virar 422 silencioso da V2.
export function buildTokenScopesPayload(state) {
  const invalid = (state?.scopes ?? []).filter((scope) => !CANONICAL_SCOPES.has(scope));
  if (invalid.length > 0) {
    throw new Error(`Escopos fora do catalogo self-service: ${invalid.join(", ")}`);
  }
  return canonicalize(state.scopes);
}

// ---------------------------------------------------------------------------
// Allowlist de IP (FS-032 fase B — create-time).
//
// FONTE DE VERDADE: a V2 (`PortalTokenCreate`, v2 backend/app/api/v1/routes/
// portal_tokens.py). Ela valida DURO e responde 422 nomeado. Tudo abaixo e
// ESPELHO client-side para UX — bloqueia o submit e explica antes da viagem,
// e nunca e a unica defesa. Divergiu do backend? Quem manda e o 422.
//
// REGRA A (decisao do owner 2026-08-12, decisoes.log FS032-DECIDIDO-AMPLIADO):
// scope de ESCRITA = todo scope que NAO termina em `:read`, EXCETO
// `simulation:create`. Deliberadamente mais ampla que um write-set curado a
// mao: lista curada envelhece calada a cada scope novo do catalogo, a regra
// por sufixo ja nasce cobrindo o proximo. `simulation:create` e a unica
// excecao porque simular nao muda estado nenhum na V2 — e leitura cara.
//
// CONTRATO BILATERAL, como o de SK_SCOPE_VALUES: mudar esta regra exige mudar
// o espelho na V2 na MESMA leva (o guarda deste lado e tokenScopes.test.js).
// ---------------------------------------------------------------------------
export const WRITE_SCOPE_EXCEPTIONS = ["simulation:create"];

const _WRITE_EXCEPTIONS = new Set(WRITE_SCOPE_EXCEPTIONS);

export function isWriteScope(scope) {
  if (typeof scope !== "string" || !scope) return false;
  if (_WRITE_EXCEPTIONS.has(scope)) return false;
  return !scope.endsWith(":read");
}

// A allowlist e OBRIGATORIA quando ha >= 1 scope de escrita na selecao.
// Reativa por construcao: a tela chama isto a cada mudanca de escopo.
export function requiresIpAllowlist(scopes) {
  return (Array.isArray(scopes) ? scopes : []).some(isWriteScope);
}

// Limites do contrato: ate 32 entradas; vazio proibido quando ha escrita.
// SO-IP INDIVIDUAL, sem CIDR/mascara (decisao do owner FS032-M2-SO-IP-ESPECIFICO,
// que dissolveu o M2 "piso de prefixo": em vez de escolher um prefixo minimo
// seguro, a allowlist so aceita host individual). Espelho da V2 (branch
// wt/fs032-ip-allowlist-create; codigo de erro `ip_allowlist_cidr_nao_aceito`)
// — a V2 e o arbitro. Efeito: qualquer entrada com `/` e recusada, e o veto ao
// wildcard `/0` vira redundante (ja barrado pelo `/`); o endereco unspecified
// (`0.0.0.0`, `::`) SEGUE recusado, agora so na forma pelada.
export const IP_ALLOWLIST_MAX = 32;

// IP de referencia do NAT de PRODUCAO. E DICA/placeholder — nunca valor
// pre-preenchido: pre-preencher autorizaria um IP que o master nao escolheu.
export const IP_ALLOWLIST_HINT_IP = "56.126.149.144";

// "Espaco" = o conjunto do `str.strip()` do Python, que e o que a V2 faz em cada
// entrada (`entry.strip()`), e NAO o do `trim()` do JS. Os dois divergem: o Python
// tira \x1c-\x1f e \x85 e NAO tira U+FEFF; o JS faz o contrario. Usar so o `trim()`
// recusaria uma forma que a V2 aceita (`\x1f1.2.3.4`). O BOM e tratado a parte, em
// `stripIpEntry`. O teste diferencial mede o conjunto contra o Python em todo o Unicode.
const PY_WHITESPACE =
  "\\t\\n\\v\\f\\r\\x1c-\\x1f \\x85\\xa0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000";
const _PY_STRIP_RE = new RegExp(`^[${PY_WHITESPACE}]+|[${PY_WHITESPACE}]+$`, "g");
// O strip da ENTRADA do campo = o do Python + U+FEFF (BOM). O BOM a base ja tirava (o
// `trim()` do JS o tira) e enviava o IP limpo, que a V2 aceita; a V2 nao o tira do texto
// cru, entao o front o limpa AQUI, uma vez, e valida e ENVIA o valor limpo. Qualquer outro
// invisivel (U+200B, U+2060...) a base tambem nao tirava e a V2 recusa: continua recusado.
const _ENTRY_STRIP_RE = new RegExp(`^[${PY_WHITESPACE}\\ufeff]+|[${PY_WHITESPACE}\\ufeff]+$`, "g");
const _PASTE_SPLIT_RE = new RegExp(`[${PY_WHITESPACE},;]+`);
const _PASTE_HAS_SEPARATOR_RE = new RegExp(`[${PY_WHITESPACE},;]`);

// Exatamente o `str.strip()` do Python (a V2 faz `entry.strip()`): os 29 code points de
// `isspace()`. Exportado para o teste que compara com o Python em todo o Unicode.
export function pyStrip(text) {
  return String(text ?? "").replace(_PY_STRIP_RE, "");
}

// O que o campo faz com cada entrada antes de validar e de ENVIAR: `pyStrip` + U+FEFF.
export function stripIpEntry(text) {
  return String(text ?? "").replace(_ENTRY_STRIP_RE, "");
}

// Texto (uma entrada por linha) -> lista limpa. Aceita virgula e ponto-e-virgula
// como separador tambem: colar de um runbook e o caminho real, e um "10.0.0.1,
// 10.0.0.2" colado nao pode virar uma entrada invalida.
export function parseIpAllowlist(text) {
  return String(text ?? "")
    .split(/[\n,;]+/)
    .map(stripIpEntry)
    .filter(Boolean);
}

// COLAR (mascara A): o texto colado vira UMA ENTRADA POR LINHA. Separador aqui =
// quebra de linha, virgula, ponto-e-virgula e QUALQUER espaco (o de um runbook
// que separa por espaco, ou "1.2.3.4 , 5.6.7.8"). So separadores e espacos a
// volta somem — e ficam VISIVEIS no campo, que passa a mostrar uma entrada por
// linha. Nenhum outro caractere e removido, nem o que parece lixo (`"1.2.3.4"`,
// `IPs:`): fica na linha, e a linha e marcada invalida com a razao.
export function splitIpAllowlistPaste(pasted) {
  return String(pasted ?? "").split(_PASTE_SPLIT_RE).filter(Boolean);
}

// Aplica o COLAR ao texto do campo — SO quando ha SEPARADOR a normalizar. Se o texto colado,
// depois do strip, nao tem separador nenhum (quebra de linha, virgula, ponto-e-virgula, espaco
// interno), devolve `null` e o navegador cola como sempre: colar um trecho DENTRO de uma
// entrada («10» selecionado em `192.168.1.10`, colar `20`) substitui a selecao em linha,
// como no campo da base. Com separador, substitui a selecao [start, end) pelas entradas
// coladas, uma por linha; cada uma ocupa a sua PROPRIA linha (se o cursor esta no meio de
// uma linha com conteudo, a colagem comeca na linha seguinte e o resto da linha original
// desce, nao se cola nele). `null` tambem quando so ha espacos/separadores. `caret` = fim
// da ultima entrada colada.
export function applyIpAllowlistPaste(text, start, end, pasted) {
  const entries = splitIpAllowlistPaste(pasted);
  if (entries.length === 0) return null;
  if (!_PASTE_HAS_SEPARATOR_RE.test(stripIpEntry(pasted))) return null;
  const source = String(text ?? "");
  const a = Math.max(0, Math.min(Number.isInteger(start) ? start : source.length, source.length));
  const b = Math.max(a, Math.min(Number.isInteger(end) ? end : a, source.length));
  let before = source.slice(0, a);
  const after = source.slice(b);
  const lineBefore = before.slice(Math.max(before.lastIndexOf("\n"), before.lastIndexOf(","), before.lastIndexOf(";")) + 1);
  if (stripIpEntry(lineBefore)) before += "\n";
  const head = before + entries.join("\n");
  const lineAfter = after.match(/^[^\n,;]*/)[0];
  const tail = stripIpEntry(lineAfter) ? `\n${after}` : after;
  return { text: head + tail, caret: head.length, entries };
}

function _isUint(text, max) {
  return /^(0|[1-9][0-9]*)$/.test(text) && Number(text) <= max;
}

// IPv4 SEM zero a esquerda: `010.0.0.1` e ambiguo (octal em algumas stacks) e
// o `ipaddress` do Python — que a V2 usa — recusa. Aceitar aqui so adiaria o 422.
function _isIpv4(text) {
  const parts = text.split(".");
  return parts.length === 4 && parts.every((part) => _isUint(part, 255));
}

// IPv6 leve -> os 8 grupos de 16 bits do endereco INTERPRETADO (numeros), ou `null` se a
// forma nao e IPv6. Grupos hex de ate 4 digitos, no maximo um `::`, IPv4 embutido permitido
// SO como o ULTIMO elemento do texto (`::ffff:1.2.3.4`). Nao pretende ser a RFC inteira — a
// V2 e o arbitro; isto so pega o erro de digitacao antes da viagem.
//
// O IPv4 embutido e lido do texto DEPOIS do ultimo `:`, e nao do ultimo grupo da juncao
// cabeca+cauda: a juncao perde a posicao do `::`, e `1.2.3.4::` (IPv4 ANTES de um `::` final)
// passava como se o IPv4 terminasse o endereco. O `ipaddress` da V2 so converte o IPv4 quando
// ele e a ULTIMA parte (`parts[-1]`) e recusa `1.2.3.4::` (corpus: ip_allowlist_entrada_invalida).
function _ipv6Hextets(text) {
  if (!text.includes(":")) return null;
  if ((text.match(/::/g) || []).length > 1) return null;
  const [head, tail = null] = text.split("::");
  const headGroups = head === "" ? [] : head.split(":");
  const tailGroups = tail === null || tail === "" ? [] : tail.split(":");
  const groups = [...headGroups, ...tailGroups];
  let embedded = [];
  const lastPart = text.slice(text.lastIndexOf(":") + 1);
  if (lastPart.includes(".")) {
    if (!_isIpv4(lastPart)) return null;
    groups.pop(); // o ultimo elemento do texto e o ultimo da juncao (nada vem depois dele)
    const o = lastPart.split(".").map(Number);
    embedded = [o[0] * 256 + o[1], o[2] * 256 + o[3]]; // o IPv4 embutido ocupa dois grupos de 16 bits
  }
  if (!groups.every((group) => /^[0-9a-fA-F]{1,4}$/.test(group))) return null;
  const slots = 8 - embedded.length;
  const hex = groups.map((group) => parseInt(group, 16));
  if (tail === null) return groups.length === slots ? [...hex, ...embedded] : null;
  if (groups.length > slots - 1) return null;
  const fill = Array(slots - groups.length).fill(0);
  return [...hex.slice(0, headGroups.length), ...fill, ...hex.slice(headGroups.length), ...embedded];
}

function _isIpv6(text) {
  return _ipv6Hextets(text) !== null;
}

// Endereco NAO-ESPECIFICADO (`0.0.0.0`, `::`) — RECUSADO por ratificacao do
// owner (decisoes.log FS032D-UNSPECIFIED-RECUSAR), fail-closed e sincronizado
// com a V2.
//
// "IP de origem 0.0.0.0" e o que uma stack escreve quando NAO SABE a origem, e
// ha pilha que trata o zero como coringa. Numa allowlist — que so existe para
// restringir — a entrada e, na melhor hipotese, inutil e, na pior, um buraco:
// recusar e a leitura fail-closed. Com a regra so-IP (sem `/`) so chega aqui a
// forma PELADA; a forma com mascara ja caiu no ramo do CIDR antes.
//
// IPv6: decidido pelo ENDERECO INTERPRETADO (os 8 grupos), nao pela forma do texto — o
// `^[0:]+$` deixava passar `::0.0.0.0` e `0:0:0:0:0:0:0.0.0.0`. Nao-especificado = os 128 bits
// a zero OU o IPv4-mapeado do `0.0.0.0` (`::ffff:0.0.0.0`, `::ffff:0:0`): o `ipaddress` do
// Python 3.12 medido (3.12.13, o do oraculo) le o mapeado pelo IPv4 (`is_unspecified` do
// `ipv4_mapped`) e a V2 recusa-o como unspecified (corpus-oracle-py312.json).
function _isUnspecified(addr, v6) {
  if (!v6) return addr.split(".").every((part) => Number(part) === 0);
  const h = _ipv6Hextets(addr);
  if (h === null) return false;
  const zero = h.every((x) => x === 0);
  const mappedZero = h.slice(0, 5).every((x) => x === 0) && h[5] === 0xffff && h[6] === 0 && h[7] === 0;
  return zero || mappedZero;
}

// COPY provisória — ratificação do owner pendente (FS-032 só-IP).
// Mora aqui (e não no COPY da tela) porque estas mensagens nascem DENTRO das
// funções de validação; o rito /myuxreview troca os dois no mesmo round.
const COPY_IP = {
  invalid: (entry) =>
    `“${String(entry ?? "").trim() || "(vazio)"}” não é um IP válido. ` +
    `Informe um IP individual por linha (ex.: ${IP_ALLOWLIST_HINT_IP} ou 2001:db8::1).`,
  // NOVA (substitui a de wildcard): a regra passou a ser só-IP individual, então
  // qualquer máscara/faixa é recusada — inclusive `/0` (que era o wildcard) e o
  // `/32` explícito. Mensagem própria: quem escreveu uma faixa não errou a
  // digitação, escolheu um formato que a regra não aceita mais.
  cidr: (entry) =>
    `“${entry}” tem máscara de rede (faixa) e não é aceito — ` +
    "informe endereços IP individuais.",
  // Mensagem PRÓPRIA, separada do erro de digitação: quem escreve `0.0.0.0` não
  // errou a digitação — quase sempre é o valor que a stack devolveu por não
  // saber a origem. A copy manda buscar o endereço real.
  unspecified: (entry) =>
    `“${entry}” é o endereço não-especificado e não é aceito na lista. ` +
    "Informe o IP de saída real da sua integração.",
  required:
    "Obrigatório para credenciais com permissão de escrita: informe ao menos " +
    "um IP autorizado.",
  tooMany: `Máximo de ${IP_ALLOWLIST_MAX} entradas — remova as excedentes.`,
};

// null = entrada OK; string = motivo. Uma entrada por vez, para a tela poder
// apontar QUAL linha esta errada.
//
// Regra SO-IP (FS032-M2-SO-IP-ESPECIFICO): qualquer `/` = faixa/mascara =
// recusado ANTES de tudo. Isso engole o antigo veto ao wildcard `/0` (agora um
// caso de CIDR). O unspecified segue recusado, na forma pelada.
export function ipAllowlistEntryError(entry) {
  const text = stripIpEntry(entry);
  if (!text) return COPY_IP.invalid(entry);
  if (text.includes("/")) return COPY_IP.cidr(text);
  // ZONA IPv6 (`fe80::1%eth0`) RECUSADA, com a razao de entrada invalida que ja
  // existe. O `ipaddress` do Python 3.12 (o da V2) a ACEITA na validacao, mas a V2
  // grava por `CAST(:ip_allowlist AS text[])::cidr[]` e o tipo `cidr` do Postgres
  // nao guarda zona (`'fe80::1%eth0/128'::cidr` => "invalid input syntax for type
  // cidr", medido em Postgres 16 LOCAL, nao em prod). A regra e "nunca recusar o
  // que o sistema consegue GUARDAR"; o que ele nao guarda a tela nao deixa seguir.
  if (text.includes("%")) return COPY_IP.invalid(text);
  const v6 = text.includes(":");
  const validAddr = v6 ? _isIpv6(text) : _isIpv4(text);
  if (!validAddr) return COPY_IP.invalid(text);
  if (_isUnspecified(text, v6)) return COPY_IP.unspecified(text);
  return null;
}

// Veredito da LISTA como conjunto (vazio x obrigatoriedade, teto). null = nada a
// dizer sobre o conjunto; o veredito por ENTRADA e `ipAllowlistEntryError`.
export function ipAllowlistListError(entries, scopes) {
  const list = Array.isArray(entries) ? entries : parseIpAllowlist(entries);
  if (list.length === 0) {
    return requiresIpAllowlist(scopes) ? COPY_IP.required : null;
  }
  if (list.length > IP_ALLOWLIST_MAX) return COPY_IP.tooMany;
  return null;
}

// Veredito da LISTA, no contexto dos scopes selecionados. null = pode enviar.
// Ordem das checagens = ordem em que o master consegue agir.
export function ipAllowlistError(entries, scopes) {
  const list = Array.isArray(entries) ? entries : parseIpAllowlist(entries);
  const listProblem = ipAllowlistListError(list, scopes);
  if (listProblem) return listProblem;
  for (const entry of list) {
    const problem = ipAllowlistEntryError(entry);
    if (problem) return problem;
  }
  return null;
}

// Marca cada ENTRADA do texto do campo (mascara A: validacao ao vivo, sem
// bloquear tecla). Mesma segmentacao de `parseIpAllowlist` (quebra de linha,
// virgula, ponto-e-virgula), mais a posicao da entrada no texto para casar com o
// cursor. `caret` = posicao do cursor no campo (ou `null` quando o campo perdeu o
// foco / acabou de receber uma colagem): a entrada que CONTEM o cursor esta sendo
// escrita — `state: "editing"`, sem veredito — e so ganha marca quando o cursor
// SAI da linha. As demais: "valid" | "invalid" (com a razao de `COPY_IP`).
// Isto e SO exibicao: quem bloqueia o envio continua sendo `ipAllowlistError`,
// sobre a lista inteira, com o cursor onde estiver.
export function ipAllowlistEntryMarks(text, caret = null) {
  const source = String(text ?? "");
  const marks = [];
  const segments = /[^\n,;]+/g;
  let match;
  while ((match = segments.exec(source)) !== null) {
    const entry = stripIpEntry(match[0]);
    if (!entry) continue;
    const start = match.index;
    const end = start + match[0].length;
    const editing = Number.isInteger(caret) && caret >= start && caret <= end;
    const error = editing ? null : ipAllowlistEntryError(entry);
    marks.push({
      entry,
      start,
      end,
      state: editing ? "editing" : error ? "invalid" : "valid",
      error,
    });
  }
  return marks;
}

// ---------------------------------------------------------------------------
// Nome da credencial — espelha `PortalTokenCreate.label` da V2
// (`min_length=3, max_length=255`). Validar AQUI, em PT-BR, evita que o master
// receba o 422 cru da V2 ("String should have at least 3 characters") depois de
// preencher o formulario inteiro.
// ---------------------------------------------------------------------------
export const LABEL_MIN = 3;
export const LABEL_MAX = 255;

export function labelError(label) {
  const trimmed = (label ?? "").trim();
  if (!trimmed) return "Informe um nome para o token";
  if (trimmed.length < LABEL_MIN) {
    return `O nome precisa ter ao menos ${LABEL_MIN} caracteres`;
  }
  if (trimmed.length > LABEL_MAX) {
    return `O nome pode ter no máximo ${LABEL_MAX} caracteres`;
  }
  return null;
}

// Fallback PT-BR para o 422 da V2 quando ele chega CRU em ingles. Sem isto o
// master le "String should have at least 3 characters" numa tela em portugues.
// Mapeamento CIRURGICO das validacoes que `PortalTokenCreate` de fato emite;
// qualquer outra coisa cai numa mensagem generica acionavel — nunca ingles.
const _V2_ERROR_PT = [
  // FS-035 — os DOIS 403 NOMEADOS do step-up 2FA (contrato em DOCS.md §5.5).
  // ANCORADOS (`^...$`) porque são o `detail` INTEIRO da resposta: casar por
  // substring pegaria uma mensagem humana que citasse o termo. O caminho
  // normal trata os dois ANTES de chegar aqui (modal de bloqueio C2 /
  // reabertura do step-up C6, em TokensAPI.jsx); esta entrada existe para que
  // nenhum caminho residual mostre o código cru `step_up_required` ao master.
  [new RegExp(`^\\s*${ERROR_TWO_FACTOR_ENROLLMENT_REQUIRED}\\s*$`, "i"),
   COPY_STEPUP.blockBody],
  [new RegExp(`^\\s*${ERROR_STEP_UP_REQUIRED}\\s*$`, "i"), COPY_STEPUP.proofExpired],
  [/at least 3 characters|min_length|String should have at least/i,
   `O nome precisa ter ao menos ${LABEL_MIN} caracteres`],
  [/at most 255 characters|max_length|String should have at most/i,
   `O nome pode ter no máximo ${LABEL_MAX} caracteres`],
  // ANTES do ramo de escopo, de propósito (FS-032): o 422 da allowlist FALA de
  // escopo por natureza ("obrigatória quando há escopo de escrita") e cairia
  // no `/scope|escopo/i` abaixo, virando "Alguma permissão selecionada não é
  // aceita" — mandando o master mexer nas permissões em vez de no campo que
  // ele deixou vazio. O 422 da V2 é o árbitro; aqui só se garante que ele
  // chegue APONTANDO PARA O CAMPO CERTO.
  [/ip_allowlist|allowlist|cidr/i,
   "Revise os IPs autorizados: a lista é obrigatória para credenciais com " +
   "permissão de escrita e aceita apenas IPs individuais (sem faixas)."],
  [/scope|escopo/i, "Alguma permissão selecionada não é aceita pela API. Revise as permissões."],
  [/field required|Field required/i, "Faltou preencher um campo obrigatório. Revise o formulário."],
];

// `detail` ja passou por formatApiErrorDetail (que devolve string em todo caso).
export function formatTokenCreateError(detail) {
  const text = typeof detail === "string" ? detail : "";
  if (!text) return "Não foi possível criar a credencial. Tente novamente.";
  for (const [pattern, message] of _V2_ERROR_PT) {
    if (pattern.test(text)) return message;
  }
  // Heuristica conservadora: so troca por generico quando o texto NAO parece
  // portugues (sem acento e sem palavra funcional PT). Mensagem ja traduzida
  // pela V2 ou pelo proxy passa intacta.
  const looksPortuguese = /[áàâãéêíóôõúüç]/i.test(text) || /\b(não|de|da|do|para|com|já)\b/i.test(text);
  return looksPortuguese
    ? text
    : "Não foi possível criar a credencial. Revise o nome e as permissões e tente novamente.";
}

// Corpo COMPLETO do POST /v2/tokens. Mesma disciplina do payload de escopos:
// sai daqui e de mais lugar nenhum, e para fail-closed quando o estado nao
// fecha (escopo fora do catalogo OU classe contradizendo os escopos).
// `ipAllowlist` = lista JA parseada (ver `parseIpAllowlist`) ou o texto cru do
// campo. Omitido/vazio E nao-obrigatorio => a chave NAO entra no corpo: o proxy
// so repassa o que existe e a V2 aplica o proprio default (regra de omissao de
// `kind`/`expires_in_days`, v2_proxy.py). Vazio COM escrita para aqui.
export function buildCreateTokenPayload(state, label, ipAllowlist) {
  const trimmed = (label ?? "").trim();
  const labelProblem = labelError(trimmed);
  if (labelProblem) throw new Error(labelProblem);
  const mismatch = kindMismatch(state);
  if (mismatch) throw new Error(mismatch);
  const scopes = buildTokenScopesPayload(state);
  // A V2 exige `scopes` com min_length=1 — parar aqui e melhor que 422 remoto.
  if (scopes.length === 0) throw new Error("Selecione ao menos um escopo");
  const entries = Array.isArray(ipAllowlist)
    ? ipAllowlist.map((entry) => stripIpEntry(entry)).filter(Boolean)
    : parseIpAllowlist(ipAllowlist);
  // Fail-closed igual ao mismatch: a UX ja bloqueia o submit, mas esta e a
  // fronteira de saida — nenhum caminho da tela pode postar uma allowlist que o
  // espelho da regra A reprova.
  const ipProblem = ipAllowlistError(entries, scopes);
  if (ipProblem) throw new Error(ipProblem);
  const payload = {
    label: trimmed,
    scopes,
    kind: CREDENTIAL_KINDS.includes(state?.kind) ? state.kind : kindForScopes(state?.scopes),
  };
  if (entries.length > 0) payload.ip_allowlist = entries;
  return payload;
}

// ---------------------------------------------------------------------------
// Rotacao — modelo criar -> migrar -> revogar (runbook da V2; NAO existe
// endpoint /rotate, e este atalho nao inventa um). O botao so pre-preenche a
// criacao com o que a credencial atual ja tem; revogar a antiga continua sendo
// um ato SEPARADO e explicito do master, depois de migrar.
// ---------------------------------------------------------------------------
// Sufixo ACENTUADO — este texto vira `label` PERSISTIDO na V2, entao a grafia
// certa tem de entrar antes do primeiro uso real. A DETECCAO (abaixo) tolera a
// forma sem acento para nao perder o par de uma rotacao ja criada.
export const ROTATION_LABEL_SUFFIX = " (rotação)";
const _ROTATION_SUFFIXES_ACEITOS = [" (rotação)", " (rotacao)"];

export function rotationLabel(label) {
  const base = (label ?? "").trim() || "Token";
  const suffixed = `${base}${ROTATION_LABEL_SUFFIX}`;
  return suffixed.length <= LABEL_MAX
    ? suffixed
    : `${base.slice(0, LABEL_MAX - ROTATION_LABEL_SUFFIX.length)}${ROTATION_LABEL_SUFFIX}`;
}

// ---------------------------------------------------------------------------
// Rotacao PENDENTE — derivada do DADO da lista, nunca de estado em memoria.
//
// PORQUE: o passo 3 do modelo (criar -> migrar -> REVOGAR) so existia enquanto
// o banner one-time estivesse na tela. Um F5, um logout ou um "Entendi" e a
// credencial antiga ficava ativa para sempre, consumindo vaga, sem nenhum sinal.
// Agora o par e reconstruido a cada carga da lista: credencial ativa N cujo
// label e exatamente `rotationLabel(O.label)` de outra credencial ativa O mais
// ANTIGA => O e uma origem de rotacao pendente.
//
// Heuristica, e assumida como tal: e o unico sinal disponivel sem coluna nova
// na V2 (nao ha `superseded_by_id` — o 0053 removeu o estado de predecessor de
// proposito). Falso positivo possivel se o master nomear a mao uma credencial
// com o sufixo; o custo e um badge a mais, nunca uma revogacao automatica.
// ---------------------------------------------------------------------------
function _rotationBase(label) {
  const text = (label ?? "").trim();
  const suffix = _ROTATION_SUFFIXES_ACEITOS.find((s) => text.endsWith(s));
  return suffix ? text.slice(0, -suffix.length) : null;
}

const _createdAt = (token) => new Date(token?.created_at ?? 0).getTime() || 0;

export function pendingRotations(tokens) {
  const active = (Array.isArray(tokens) ? tokens : []).filter((t) => t?.status === "active");
  const pairs = [];
  active.forEach((successor) => {
    const base = _rotationBase(successor.label);
    if (base === null) return;
    // A origem tem de ser ATIVA, mais ANTIGA, e o label do sucessor tem de ser
    // exatamente o que `rotationLabel` teria gerado (cobre ate a truncagem).
    const origins = active
      .filter(
        (origin) =>
          origin !== successor &&
          rotationLabel(origin.label) === `${base}${ROTATION_LABEL_SUFFIX}` &&
          _createdAt(origin) < _createdAt(successor)
      )
      .sort((a, b) => _createdAt(a) - _createdAt(b));
    if (origins.length > 0) pairs.push({ origin: origins[0], successor });
  });
  return pairs;
}

// Índice id-da-origem -> sucessor, para a lista consultar em O(1) por linha.
export function pendingRotationByOriginId(tokens, keyOf = (t) => t?.token_id || t?.id) {
  const index = new Map();
  pendingRotations(tokens).forEach(({ origin, successor }) => {
    const key = keyOf(origin);
    const current = index.get(key);
    // Mais de um sucessor: fica o mais RECENTE (foi para ele que se migrou).
    if (!current || _createdAt(successor) > _createdAt(current)) index.set(key, successor);
  });
  return index;
}

// Devolve o estado de criacao pre-preenchido E o que teve de ser DESCARTADO:
// uma credencial emitida pelo Backoffice pode carregar escopos do catalogo
// tecnico da V2 (sem contagem medida aqui) que o self-service nao oferece. Descartar em silencio geraria
// uma "rotacao" com menos poder que a original — a tela AVISA.
export function rotationPrefill(token) {
  const original = Array.isArray(token?.scopes) ? token.scopes : [];
  const scopes = canonicalize(original);
  const droppedScopes = original.filter((scope) => !CANONICAL_SCOPES.has(scope));
  // SK14 (owner C1014458, SPEC §3.2.2; forma ESTREITA, cockpit): a rotacao HONRA
  // a classe emitida. Uma credencial `SK` cujos escopos persistidos sao
  // EXATAMENTE uma forma aceite (14, 12 ou 9 — igualdade de conjunto, como a V2)
  // rotaciona para o `full` CORRENTE (os 14): a rotacao cria uma credencial NOVA
  // de 14 e a antiga nao muda. Fail-closed: subconjunto proprio (ex.: a SK so de
  // leitura do Backoffice), vazio ou qualquer outra lista NAO e alargada — segue
  // o caminho anterior abaixo. A classe vem de `issuedCredentialKind` (campo
  // `kind` > prefixo > escopos).
  if (issuedCredentialKind(token) === "SK" && isAcceptedSkShape(original)) {
    const state = {
      kind: "SK",
      mode: "full",
      scopes: [...TOKEN_SCOPE_PRESETS.full],
      customScopes: null,
    };
    return { label: rotationLabel(token?.label), state, droppedScopes };
  }
  // Fora disso, o comportamento anterior: `full` (== SK) so quando a origem
  // traz EXATAMENTE o recorte dos 14 — nao basta "ter muitos escopos": uma
  // credencial com os 17 do catalogo nao e SK e rotacionar como SK levaria 422
  // da V2.
  //
  // A classe sai da lista CRUA (`original`), NAO da filtrada — mesma semantica
  // de `kindForScopes`. Classificar pela filtrada trocaria a classe em silencio:
  // "os 14 + um escopo do catalogo tecnico do BO" perderia o desconhecido no
  // filtro e prefillaria SK/full, enquanto `kindForScopes` chama o MESMO token de
  // RK. O prefill fica custom/RK com os 14 marcados; o guard RK-nao-superset
  // acusa o superset e forca o master a decidir (desmarcar uma, ou assumir a SK)
  // em vez de emitir uma SK achando que e equivalente. Os ESCOPOS do prefill
  // continuam sendo so os validos (`scopes`), e o que caiu vem em `droppedScopes`.
  const mode = kindForScopes(original) === "SK" ? "full" : "custom";
  const state = {
    kind: kindForMode(mode),
    mode,
    scopes,
    customScopes: mode === "custom" ? scopes : null,
  };
  return { label: rotationLabel(token?.label), state, droppedScopes };
}

export function tokenCapacityReached(activeCount, activeLimit) {
  return Number.isInteger(activeLimit) && activeLimit >= 0 && activeCount >= activeLimit;
}
